export default function($) {

  function updateToggleVisibility() {
    var $desc = $('.js-cat-description');
    var isExpanded = $desc.hasClass('h-full');
    if (isExpanded) return;

    if( !isOverflown( $desc ) ) {
      $('.js-trigger-toggle').hide();
    } else {
      $('.js-trigger-toggle').show();
    }
  }

  updateToggleVisibility();

  $(window).on('resize', updateToggleVisibility);

  $( ".js-trigger-toggle" ).click(function() {
    $( ".js-cat-description" ).toggleClass('h-full');
    $( ".js-cat-description" ).toggleClass('h-24');
    $( ".js-cat-description-overlay" ).toggleClass('hidden');
    var $x = $("#toggleText");
    if ($x.html() === "Lire plus") {
      $x.html("Lire moins");
    } else {
      $x.html("Lire plus");
    }
  });

  function isOverflown(element) {
    return element.prop('scrollHeight') > element.height();
  }
}
